<template>
  <div>
    <q-select
      v-if="buttonType"
      v-model="selectorButtonType"
      class="col-3 q-pr-sm q-pb-sm"
      :options="$mh.asOptions(BUTTON_TYPES)"
      map-options
      emit-value
      :label="buttonTypeLabel"
    />
    <color-selection
      v-if="colorName || customColorHex"
      class="col-6 q-pr-sm q-pb-sm"
      :color-name="selectedColorName"
      :custom-color-hex="selectedColorHex"
      :label="colorLabel"
      @update:model-value="setColor"
    />
    <div
      v-if="selectorButtonType !== BUTTON_TYPES.FLAT"
      class="col-3 q-pr-sm q-pb-sm"
    >
      <q-item-label>{{ borderRadiusLabel }}</q-item-label>
      <q-slider
        v-model="selectedButtonRadius"
        label
        label-always
        switch-label-side
        type="number"
        :min="0"
        :max="32"
        :step="4"
      />
    </div>
  </div>
</template>

<script>
import { BUTTON_TYPES } from 'src/models/page/Section'
import ColorSelection from 'src/modules/admin/components/ColorSelection'

export default {
  name: 'ButtonStyleEditor',
  components: {
    ColorSelection
  },
  props: {
    buttonType: {
      type: String,
      required: false,
      default: null
    },
    buttonTypeLabel: {
      type: String,
      required: false,
      default: 'Button Type'
    },
    colorName: {
      type: String,
      required: false,
      default: null
    },
    customColorHex: {
      type: String,
      required: false,
      default: null
    },
    colorLabel: {
      type: String,
      required: false,
      default: 'Button Color'
    },
    buttonBorderRadius: {
      type: Number,
      required: false,
      default: 4
    },
    borderRadiusLabel: {
      type: String,
      required: false,
      default: 'Border Radius Type'
    }
  },
  emits: ['update:model-value'],
  data () {
    return {
      selectorButtonType: this.buttonType,
      selectedColorName: this.colorName,
      selectedColorHex: this.customColorHex,
      selectedButtonRadius: this.buttonBorderRadius
    }
  },
  watch: {
    selectorButtonType () {
      this.emitValues()
    },
    selectedButtonRadius () {
      this.emitValues()
    },
    selectedColorName () {
      this.emitValues()
    },
    selectedColorHex () {
      this.emitValues()
    }
  },
  created () {
    _.extend(this, {
      BUTTON_TYPES
    })
  },
  methods: {
    setColor (colorName, customColorHex) {
      this.selectedColorName = colorName
      this.selectedColorHex = customColorHex
    },
    emitValues () {
      this.$emit('update:model-value', this.selectorButtonType, this.selectedColorName, this.selectedColorHex, this.selectedButtonRadius)
    }
  }
}
</script>
